import * as React from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
    Divider,
    Box,
    Typography,
    useTheme,
    useMediaQuery
} from "@mui/material";
import { useTranslation } from 'react-i18next';
import DriversDropdownList from "./DriversDropdownList";
import { filter, includes, isEmpty, get } from 'lodash';
import { LoadingButton } from '@mui/lab';
import PropTypes from "prop-types";
import { useState, useMemo } from "react";
import { useSelector } from 'react-redux';
// import SelectedDriversStack from './SelectedDriversStack';

const AssignDriversDialog = ({
    open,
    mode,
    // drivers,
    maxDriversCount,
    didCancel,
    didConfirmSelection,
    loading,
    error,
    isSuccess,
    ...rest
}) => {

    const { t } = useTranslation();

    const [selectedDrivers, setSelectedDrivers] = useState([]);
    const [selectedDriver, setSelectedDriver] = useState(null);
    const { assignOrderPending, assignOrderSuccess, skippedAssingedOrder, assignOrderError } = useSelector(state => state.entities.assignOrders)

    const settings = useMemo(_ => {
        if (mode === "single" || mode === "multi" && Number(maxDriversCount) === 1) {
            return {
                mode: "single",
                title: "Driver Assignment",
                extraTitle: "",
            }
        }
        if (mode === "multi" && Number(maxDriversCount) > 1) {
            return {
                mode: "multi",
                title: "Drivers Assignment",
                extraTitle: "(Multiple drivers allowed)",
            }
        }
    }, [mode])

    const handleSelect = drivers => {
        if (settings.mode === "single") setSelectedDriver(drivers);
        if (settings.mode === "multi") {
            if (drivers.length > maxDriversCount) return
            //  !includes(selectedDrivers, driverId) && 
            setSelectedDrivers([...drivers]);
        }
    }

    // const handleRemoveDriver = driverId => {
    //     if (settings.mode === "multi") {
    //         const newSelectedDrivers = filter(selectedDrivers, selectedDriverId => selectedDriverId !== driverId)
    //         setSelectedDrivers([...newSelectedDrivers])
    //     };
    // }

    // const unselectedDrivers = useMemo(_ => {
    //     return filter(drivers, ({ id }) => !includes(selectedDrivers, id));
    // }, [selectedDrivers, drivers])

    const handleConfirm = _ => {
        let selection;
        if (settings.mode === "single") selection = selectedDriver.id;
        if (settings.mode === "multi") selection = [...selectedDrivers.map(driver => driver.id)];
        didConfirmSelection(selection)
    }

    const handleCancel = _ => {
        setSelectedDrivers([]);
        setSelectedDriver(null);
        didCancel();
    }

    React.useEffect(() => {
        if(!open) {
            setSelectedDrivers([]);
            setSelectedDriver(null);
        }   
    }, [open])

    const theme = useTheme()
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Dialog
            {...rest}
            onClose={e => e.preventDefault}
            open={open}
            fullWidth={true}
            fullScreen={fullScreen}
        >
            <DialogTitle>
                {`${t(get(settings, 'title'))} ${t(get(settings, 'extraTitle'))}`}
            </DialogTitle>
            <Divider />
            {assignOrderSuccess &&
                <Typography color="green.main" mx={3} mt={1}>
                    {t("Assigned Successfully")}
                </Typography>
            }
            {/* {(!!skippedAssingedOrder || !!assignOrderError) && <DialogContent sx={{py: 1}}>
                {!!skippedAssingedOrder && <Typography color="error">{t("skipIncompletedOrderDriverMessage", { count: skippedAssingedOrder })}</Typography>}
                {!!assignOrderError && <Typography color="error">{t(assignOrderError)}</Typography>}
            </DialogContent>} */}
            <DialogContent
                sx={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}
            >
                {/* {
                    settings.mode === 'multi' && !isEmpty(selectedDrivers) &&
                    <SelectedDriversStack
                        drivers={filter(drivers, ({ id }) => includes(selectedDrivers, id))}
                        didDelete={handleRemoveDriver}
                        sx={{ mb: 3 }}
                    />
                } */}
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <DriversDropdownList
                        // drivers={drivers}
                        selectedDrivers={selectedDrivers}
                        selectedDriver={selectedDriver}
                        didSelectDriver={handleSelect}
                        mode={settings.mode}
                    // value={settings.mode === "single" ? selectedDrivers[0] : ""}
                    // disabled={maxDriversCount <= selectedDrivers.length}
                    />
                </Box>
                {
                    settings.mode === 'multi' &&
                    <Typography variant="subtitle1" mt={3}>
                        {t("maxDriversCountDisclaimer", { maxDriversCount })}
                    </Typography>
                }
            </DialogContent>
            <Divider />
            <DialogActions sx={{justifyContent: "space-between", flexDirection:"row-reverse"}}>
                <Box>
                    <Button
                        sx={{ textTransform: "none", marginInlineEnd: '16px', mx: 1 }}
                        disabled={assignOrderPending}
                        variant="contained"
                        onClick={handleCancel}
                        disableElevation
                    >
                        {t("Cancel")}
                    </Button>
                    <LoadingButton
                        sx={{ textTransform: "none", marginInlineEnd: '16px', mx: 1 }}
                        variant="contained"
                        onClick={handleConfirm}
                        disabled={(settings.mode === "multi" ? isEmpty(selectedDrivers) : selectedDriver === null) || isSuccess}
                        loading={assignOrderPending || loading}
                        disableElevation
                    >
                        {t('Confirm')}
                    </LoadingButton>
                </Box>
                {!!error && <Typography color="error">{error}</Typography>}

            </DialogActions>
        </Dialog>
    )
}

AssignDriversDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    mode: PropTypes.oneOf(['single', 'multi']),
    // drivers: PropTypes.array.isRequired,
    maxDriversCount: function (props, propName, componentName) {
        if (props['mode'] === 'multi' && !/^\d+$/.test(props[propName])) {
            return new Error(
                'Invalid prop `' + propName + '` supplied to' +
                ' `' + componentName + '`. Expected a number.'
            );
        }
    },
    didCancel: PropTypes.func.isRequired,
    didConfirmSelection: PropTypes.func.isRequired,
    // pending: PropTypes.bool.isRequired
};

AssignDriversDialog.defaultProps = {
    mode: "single",
};

export default AssignDriversDialog